import { render, staticRenderFns } from "./PatientFileListTable.vue?vue&type=template&id=41e2e776&"
import script from "./PatientFileListTable.vue?vue&type=script&lang=ts&"
export * from "./PatientFileListTable.vue?vue&type=script&lang=ts&"
import style0 from "./PatientFileListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VChip,VIcon,VSimpleCheckbox})
